export default {
  list(state) {
    return state.tasks;
  },
};
